import {
  TravelerTrackerStatus,
  TravlerTrackerAction,
} from "../reducers/travelerTracker";

//import {AIRLINES} from 'src/common/constants';
export const ACTION_TYPE = "TRAVELER_TRACKER";
export const GET_STATUSES = `${ACTION_TYPE}_GET_STATUSES` as const;
export const GET_STATUSES_INVOKED =
  `${ACTION_TYPE}_GET_STATUSES_INVOKED` as const;
export const GET_STATUSES_SUCCESS =
  `${ACTION_TYPE}_GET_STATUSES_SUCCESS` as const;

export const getStatuses = (id: string): TravlerTrackerAction => ({
  type: GET_STATUSES,
  id,
});
export const getStatusesInvoked = (id): TravlerTrackerAction => ({
  type: GET_STATUSES_INVOKED,
  id,
});
export const getStatusesSuccess = (
  statuses: TravelerTrackerStatus[],
  id: string
): TravlerTrackerAction => ({
  type: GET_STATUSES_SUCCESS,
  statuses,
  id,
});
